import styled, { css } from 'styled-components';

import type { ComplianceDocumentStatus } from '../../../types/api';
import { getComplianceStatusLabel } from '../lib/labels';

const Badge = styled.span<{ $status: ComplianceDocumentStatus }>`
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-2);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: none;
  letter-spacing: 0.04em;
  line-height: 1;
  white-space: nowrap;

  ${(props) => {
    switch (props.$status) {
      case 'active':
        return css`
          background: var(--success-100);
          color: var(--success-600);
        `;
      case 'expired':
        return css`
          background: var(--danger-100);
          color: var(--danger-600);
        `;
      case 'archived':
        return css`
          background: var(--neutral-100);
          color: var(--text-muted);
        `;
      case 'draft':
      default:
        return css`
          background: var(--warning-100);
          color: var(--warning-600);
        `;
    }
  }}
`;

interface ComplianceStatusBadgeProps {
  status: ComplianceDocumentStatus;
  className?: string;
}

export const ComplianceStatusBadge = ({
  status,
  className,
}: ComplianceStatusBadgeProps) => {
  return (
    <Badge className={className} $status={status}>
      {getComplianceStatusLabel(status)}
    </Badge>
  );
};

ComplianceStatusBadge.displayName = 'ComplianceStatusBadge';
